<template>
  <v-card
    class="mx-auto mb-3"
    max-width="600"
    :loading="loading"
    :disabled="loading"
    v-if="is_authorized_officer"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1 class="pa-0">สวมสิทธิ์แทนผู้รายงานตัว</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-form ref="form" v-model="validSurrogated" @submit.prevent="">
      <v-card-text>
        <v-text-field
          label="เลขที่ใบสมัคร"
          v-model="inputSurrogatedRegisterId"
          type="text"
          :rules="surrogetedStudentRules"
          required
        ></v-text-field>
      </v-card-text>
      <router-link to="/find_edit">
        <p class="text-right mr-3">
          {{ $t("officer.find_edit_data") }}
        </p>
      </router-link>
      <v-card-actions class="d-flex justify-center pb-3">
        <v-btn
          type="submit"
          color="primary"
          variant="flat"
          elevation="2"
          :disabled="!validSurrogated"
          @click="loginSurrogatedStudent"
          >Login</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>

  <v-card
    max-width="1000"
    class="pa-0 mx-auto"
    :loading="loading"
    :disabled="loading"
    :key="rand"
    v-if="surrogated_student_info"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1>
          ระบบรายงานตัวออนไลน์ (สำหรับเจ้าหน้าที่ตรวจ)
          <v-icon class="pl-2">mdi-shield-check</v-icon>
        </h1>
      </v-toolbar-title>
      <v-btn
        elevation="3"
        class="float-right mr-4"
        color="#9D00FF"
        variant="flat"
        to="/main"
        append-icon="mdi-account-switch"
        >สวมสิทธิ์นักศึกษา
      </v-btn>
    </v-toolbar>

    <v-card-text
      class="pa-0 pa-sm-2 pa-md-3 pa-lg-4 pa-xl-4 mt-3 mt-sm-0 mt-sm-0"
    >
    <v-card class="show-name" elevation="0" rounded="0">
      {{
        objectTranslator(
          surrogated_student_info,
          "STUDENT_FNAME"
        )
      }}
      {{
        objectTranslator(
          surrogated_student_info,
          "STUDENT_LNAME"
        )
      }}
    </v-card>
      <v-card variant="outlined" class="mx-auto mt-2 mb-5">
        <v-row justify="space-around">
          <v-col cols="12">
            <v-card
              class="mx-auto"
              elevation="0"
              style="border: 0px solid #6edff6"
            >
              <v-card-title>ข้อมูลนักศึกษา</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    ชื่อ-นามสกุล :
                    <span class="pb-1 font-weight-bold">
                      {{
                        objectTranslator(
                          surrogated_student_info,
                          "STUDENT_FNAME"
                        )
                      }}
                      {{
                        objectTranslator(
                          surrogated_student_info,
                          "STUDENT_LNAME"
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    ระดับ :
                    <span class="pb-1 font-weight-bold">
                      {{
                        inlineTranslator({
                          th: SectionFirst.level_id_TH,
                          en: SectionFirst.level_id_EN,
                        })
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    {{
                      inlineTranslator({
                        th: SectionFirst.prefix_name_TH + " :",
                        en: SectionFirst.prefix_name_EN,
                      })
                    }}
                    <span class="pb-1 font-weight-bold">
                      {{
                        inlineTranslator({
                          th: SectionFirst.faculty_TH,
                          en: SectionFirst.faculty_EN,
                        })
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    สาขา :
                    <span class="pb-1 font-weight-bold">
                      {{
                        inlineTranslator({
                          th: SectionFirst.curriculum_TH,
                          en: SectionFirst.curriculum_EN,
                        })
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <!-- ส่วน ตรวจผลการผ่าน/ไม่ผ่าน -->
      <v-card variant="outlined" class="mx-auto mb-5">
        <!-- ส่วนแสดง มีสิ่งที่ต้องแก้ไข -->
        <v-col>
          <v-card
            v-if="
              matriculation_id === '2' ||
              (matriculation_id === '1' &&
                (commentPhoto || has_commentDocument))
            "
            class="rounded-shaped bg-error mx-auto mb-3"
            elevation="3"
            width="700"
            style="border: 3px solid #b22222"
          >
            <v-card-item class="custom-text">
              <v-card-title class="mt-2">
                <h1>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ $t("main.comment") }}
                </h1>
              </v-card-title>
              <v-card-text class="ml-5">
                <div
                  v-show="
                    !is_lock_photo || (matriculation_id === '1' && commentPhoto)
                  "
                  class="mt-3"
                >
                  <span class="font-weight-bold">
                    <v-icon class="mdi-rotate-270"
                      >mdi-triangle-small-down</v-icon
                    >
                    {{ $t("main.has_comment_for_photo") }} {{ commentPhoto }}
                    <v-btn
                      class="text-none ml-1 my-auto"
                      color="#f8d7da"
                      variant="flat"
                      elevation="2"
                      size="x-small"
                      @click="navigateToSection(8)"
                    >
                      Click
                    </v-btn>
                  </span>
                </div>
                <div
                  v-show="
                    !is_lock_document ||
                    (matriculation_id === '1' && has_commentDocument)
                  "
                  class="mt-3"
                >
                  <span class="font-weight-bold">
                    <v-icon class="mdi-rotate-270"
                      >mdi-triangle-small-down</v-icon
                    >
                    {{ $t("main.has_comment_for_document") }}
                    <v-btn
                      class="text-none ml-1 my-auto"
                      color="#f8d7da"
                      variant="flat"
                      elevation="2"
                      size="x-small"
                      @click="navigateToSection(9)"
                    >
                      Click
                    </v-btn>
                  </span>
                </div>
              </v-card-text>
            </v-card-item>
          </v-card>
        </v-col>
        <v-card-text
          ><h2 class="text-center pt-4">
            สถานะของนักศึกษาในปัจจุบัน :
            <v-chip :color="matriculation_status_color">
              <h2>
                {{
                  inlineTranslator({
                    th: matriculation_status_TH,
                    en: matriculation_status_EN,
                  })
                }}
              </h2>
            </v-chip>
          </h2>
          <v-row justify="space-between" class="pt-4"
            ><v-col class="text-right"
              ><v-btn
                size="x-large"
                :color="matriculation_id === '2' ? 'gray' : 'error'"
                variant="elevated"
                elevation="5"
                @click="setMatriculationStatus('2')"
                :disabled="matriculation_id === '2'"
                ><h2>ตรวจเอกสารไม่ผ่าน</h2></v-btn
              ></v-col
            >
            <v-col class="text-center my-auto"
              ><v-icon>mdi-arrow-left-bold</v-icon> เปลี่ยนสถานะการตรวจสอบ
              <v-icon>mdi-arrow-right-bold</v-icon></v-col
            >
            <v-col class="text-left"
              ><v-btn
                size="x-large"
                :color="matriculation_id === '3' ? 'gray' : 'success'"
                variant="elevated"
                elevation="5"
                @click="setMatriculationStatus('3')"
                :disabled="matriculation_id === '3'"
                ><h2>รายงานตัวสำเร็จ</h2></v-btn
              ></v-col
            ></v-row
          ></v-card-text
        ><v-card-text class="text-center">
          <h2 class="pb-1">รายการข้อมูล</h2>
          <v-row
            ><v-col cols="12" sm="7" class="my-auto"
              >ส่วนที่ 1 [หน้า 1-7] ข้อมูล สจล.1 </v-col
            ><v-col cols="12" sm="5">
              <div class="d-flex">
                <v-icon
                  size="x-large"
                  class="my-auto pr-5"
                  :color="is_lock_kmitl1 === 1 ? 'error' : 'success'"
                  :icon="
                    is_lock_kmitl1 === 1 ? 'mdi-lock' : 'mdi-lock-open-variant'
                  "
                ></v-icon>
                <v-switch
                  v-model="is_lock_kmitl1"
                  :color="is_lock_kmitl1 === 1 ? 'error' : 'success'"
                  :label="`สถานะ: ${is_lock_kmitl1 === 1 ? 'Lock' : 'Unlock'}`"
                  :false-value="1"
                  :true-value="0"
                  @change="changeLock('LOCK_KMITL1', is_lock_kmitl1)"
                  hide-details
                ></v-switch></div></v-col
            ><v-col cols="12" sm="7" class="my-auto"
              >ส่วนที่ 2 [หน้าที่ 8] อัปโหลดรูปนักศึกษา
            </v-col>
            <v-col cols="12" sm="5">
              <div class="d-flex">
                <v-icon
                  size="x-large"
                  class="my-auto pr-5"
                  :color="is_lock_photo === 1 ? 'error' : 'success'"
                  :icon="
                    is_lock_photo === 1 ? 'mdi-lock' : 'mdi-lock-open-variant'
                  "
                ></v-icon>
                <v-switch
                  v-model="is_lock_photo"
                  :color="is_lock_photo === 1 ? 'error' : 'success'"
                  :label="`สถานะ: ${is_lock_photo === 1 ? 'Lock' : 'Unlock'}`"
                  :false-value="1"
                  :true-value="0"
                  @change="changeLock('LOCK_PHOTO', is_lock_photo)"
                  hide-details
                ></v-switch></div></v-col
            ><v-col cols="12" sm="7" class="my-auto">
              ส่วนที่ 3 [หน้าที่ 9] อัปโหลดเอกสารต่าง ๆ ของนักศึกษา
            </v-col>
            <v-col cols="12" sm="5"
              ><div class="d-flex">
                <v-icon
                  size="x-large"
                  class="my-auto pr-5"
                  :color="is_lock_document === 1 ? 'error' : 'success'"
                  :icon="
                    is_lock_document === 1
                      ? 'mdi-lock'
                      : 'mdi-lock-open-variant'
                  "
                ></v-icon>
                <v-switch
                  v-model="is_lock_document"
                  :color="is_lock_document === 1 ? 'error' : 'success'"
                  :label="`สถานะ: ${
                    is_lock_document === 1 ? 'Lock' : 'Unlock'
                  }`"
                  :false-value="1"
                  :true-value="0"
                  @change="changeLock('LOCK_UPLOAD', is_lock_document)"
                  hide-details
                >
                </v-switch>
              </div> </v-col
          ></v-row> </v-card-text
      ></v-card>

      <SectionOne v-model="SectionFirst" id="section-1" />

      <v-card class="rounded-0 mx-auto">
        <v-toolbar color="#A0522D" flat id="section-8">
          <v-toolbar-title>
            <h1>{{ $t("info_card.title_page8") }}</h1>
          </v-toolbar-title>
        </v-toolbar>
        <SectionTwo class="mt-3" />
        <div class="text-center ma-2">
          <v-chip
            size="large"
            :color="commentPhoto == '' ? 'success' : 'error'"
            :append-icon="
              commentPhoto == ''
                ? 'mdi-check-circle-outline'
                : 'mdi-close-circle'
            "
          >
            <h6>{{ commentPhoto == "" ? "ผ่าน" : "ไม่ผ่าน" }}</h6>
          </v-chip>
        </div>
        <div class="d-flex justify-center mb-4">
          <v-btn @click="setStatusAndCommentPhoto(1)" color="success"
            >บันทึก:ผ่าน</v-btn
          ><v-btn
            color="error"
            variant="outlined"
            class="ml-2"
            @click="showComment = !showComment"
            >ไม่ผ่าน (กดเพื่อระบุ comment)
          </v-btn>
        </div>
        <v-card
          color="grey-lighten-3"
          elevation="3"
          class="pa-3 ma-3"
          v-if="showComment == true || commentPhoto != ''"
        >
          <h2 class="pb-1">
            Comment การอัปโหลดรูป : กรอกกรณีนักศึกษาอัปโหลดรูปไม่ถูกต้อง
          </h2>
          <v-textarea
            v-model="commentPhoto"
            class="pa-2"
            clearable
            variant="solo-filled"
          >
          </v-textarea>
          <div class="d-flex justify-center">
            <v-btn
              @click="setStatusAndCommentPhoto(0)"
              color="error"
              class="ml-2"
              >บันทึก:ไม่ผ่าน</v-btn
            >
          </div>
        </v-card>
      </v-card>

      <Section3ForOfficer :fetch_all_lock="fetch_all_lock" />

      <v-card variant="outlined" class="mx-auto mt-5 mb-5">
        <v-row justify="space-around">
          <v-col cols="12">
            <v-card
              class="mx-auto"
              elevation="0"
              style="border: 0px solid #6edff6"
              id="section-10"
            >
              <v-card-title>ข้อมูลนักศึกษา</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    ชื่อ-นามสกุล :
                    <span class="pb-1 font-weight-bold">
                      {{
                        objectTranslator(
                          surrogated_student_info,
                          "STUDENT_FNAME"
                        )
                      }}
                      {{
                        objectTranslator(
                          surrogated_student_info,
                          "STUDENT_LNAME"
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    ระดับ :
                    <span class="pb-1 font-weight-bold">
                      {{
                        inlineTranslator({
                          th: SectionFirst.level_id_TH,
                          en: SectionFirst.level_id_EN,
                        })
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    {{
                      inlineTranslator({
                        th: SectionFirst.prefix_name_TH + " :",
                        en: SectionFirst.prefix_name_EN,
                      })
                    }}
                    <span class="pb-1 font-weight-bold">
                      {{
                        inlineTranslator({
                          th: SectionFirst.faculty_TH,
                          en: SectionFirst.faculty_EN,
                        })
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    สาขา :
                    <span class="pb-1 font-weight-bold">
                      {{
                        inlineTranslator({
                          th: SectionFirst.curriculum_TH,
                          en: SectionFirst.curriculum_EN,
                        })
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <!-- ส่วน ตรวจผลการผ่าน/ไม่ผ่าน -->
      <v-card variant="outlined" class="mx-auto mb-5">
        <!-- ส่วนแสดง มีสิ่งที่ต้องแก้ไข -->
        <v-col>
          <v-card
            v-if="
              matriculation_id === '2' ||
              (matriculation_id === '1' &&
                (commentPhoto || has_commentDocument))
            "
            class="rounded-shaped bg-error mx-auto mb-3"
            elevation="3"
            width="700"
            style="border: 3px solid #b22222"
          >
            <v-card-item class="custom-text">
              <v-card-title class="mt-2">
                <h1>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ $t("main.comment") }}
                </h1>
              </v-card-title>
              <v-card-text class="ml-5">
                <div
                  v-show="
                    !is_lock_photo || (matriculation_id === '1' && commentPhoto)
                  "
                  class="mt-3"
                >
                  <span class="font-weight-bold">
                    <v-icon class="mdi-rotate-270"
                      >mdi-triangle-small-down</v-icon
                    >
                    {{ $t("main.has_comment_for_photo") }} {{ commentPhoto }}
                    <v-btn
                      class="text-none ml-1 my-auto"
                      color="#f8d7da"
                      variant="flat"
                      elevation="2"
                      size="x-small"
                      @click="navigateToSection(8)"
                    >
                      Click
                    </v-btn>
                  </span>
                </div>
                <div
                  v-show="
                    !is_lock_document ||
                    (matriculation_id === '1' && has_commentDocument)
                  "
                  class="mt-3"
                >
                  <span class="font-weight-bold">
                    <v-icon class="mdi-rotate-270"
                      >mdi-triangle-small-down</v-icon
                    >
                    {{ $t("main.has_comment_for_document") }}
                    <v-btn
                      class="text-none ml-1 my-auto"
                      color="#f8d7da"
                      variant="flat"
                      elevation="2"
                      size="x-small"
                      @click="navigateToSection(9)"
                    >
                      Click
                    </v-btn>
                  </span>
                </div>
              </v-card-text>
            </v-card-item>
          </v-card>
        </v-col>
        <v-card-text
          ><h2 class="text-center pt-4">
            สถานะของนักศึกษาในปัจจุบัน :
            <v-chip :color="matriculation_status_color">
              <h2>
                {{
                  inlineTranslator({
                    th: matriculation_status_TH,
                    en: matriculation_status_EN,
                  })
                }}
              </h2>
            </v-chip>
          </h2>
          <v-row justify="space-between" class="pt-4"
            ><v-col class="text-right"
              ><v-btn
                size="x-large"
                :color="matriculation_id === '2' ? 'gray' : 'error'"
                variant="elevated"
                elevation="5"
                @click="setMatriculationStatus('2')"
                :disabled="matriculation_id === '2'"
                ><h2>ตรวจเอกสารไม่ผ่าน</h2></v-btn
              ></v-col
            >
            <v-col class="text-center my-auto"
              ><v-icon>mdi-arrow-left-bold</v-icon> เปลี่ยนสถานะการตรวจสอบ
              <v-icon>mdi-arrow-right-bold</v-icon></v-col
            >
            <v-col class="text-left"
              ><v-btn
                size="x-large"
                :color="matriculation_id === '3' ? 'gray' : 'success'"
                variant="elevated"
                elevation="5"
                @click="setMatriculationStatus('3')"
                :disabled="matriculation_id === '3'"
                ><h2>รายงานตัวสำเร็จ</h2></v-btn
              ></v-col
            ></v-row
          ></v-card-text
        ><v-card-text class="text-center">
          <h2 class="pb-1">รายการข้อมูล</h2>
          <v-row
            ><v-col cols="12" sm="7" class="my-auto"
              >ส่วนที่ 1 [หน้า 1-7] ข้อมูล สจล.1 </v-col
            ><v-col cols="12" sm="5">
              <div class="d-flex">
                <v-icon
                  size="x-large"
                  class="my-auto pr-5"
                  :color="is_lock_kmitl1 === 1 ? 'error' : 'success'"
                  :icon="
                    is_lock_kmitl1 === 1 ? 'mdi-lock' : 'mdi-lock-open-variant'
                  "
                ></v-icon>
                <v-switch
                  v-model="is_lock_kmitl1"
                  :color="is_lock_kmitl1 === 1 ? 'error' : 'success'"
                  :label="`สถานะ: ${is_lock_kmitl1 === 1 ? 'Lock' : 'Unlock'}`"
                  :false-value="1"
                  :true-value="0"
                  @change="changeLock('LOCK_KMITL1', is_lock_kmitl1)"
                  hide-details
                ></v-switch></div></v-col
            ><v-col cols="12" sm="7" class="my-auto"
              >ส่วนที่ 2 [หน้าที่ 8] อัปโหลดรูปนักศึกษา
            </v-col>
            <v-col cols="12" sm="5">
              <div class="d-flex">
                <v-icon
                  size="x-large"
                  class="my-auto pr-5"
                  :color="is_lock_photo === 1 ? 'error' : 'success'"
                  :icon="
                    is_lock_photo === 1 ? 'mdi-lock' : 'mdi-lock-open-variant'
                  "
                ></v-icon>
                <v-switch
                  v-model="is_lock_photo"
                  :color="is_lock_photo === 1 ? 'error' : 'success'"
                  :label="`สถานะ: ${is_lock_photo === 1 ? 'Lock' : 'Unlock'}`"
                  :false-value="1"
                  :true-value="0"
                  @change="changeLock('LOCK_PHOTO', is_lock_photo)"
                  hide-details
                ></v-switch></div></v-col
            ><v-col cols="12" sm="7" class="my-auto">
              ส่วนที่ 3 [หน้าที่ 9] อัปโหลดเอกสารต่าง ๆ ของนักศึกษา
            </v-col>
            <v-col cols="12" sm="5"
              ><div class="d-flex">
                <v-icon
                  size="x-large"
                  class="my-auto pr-5"
                  :color="is_lock_document === 1 ? 'error' : 'success'"
                  :icon="
                    is_lock_document === 1
                      ? 'mdi-lock'
                      : 'mdi-lock-open-variant'
                  "
                ></v-icon>
                <v-switch
                  v-model="is_lock_document"
                  :color="is_lock_document === 1 ? 'error' : 'success'"
                  :label="`สถานะ: ${
                    is_lock_document === 1 ? 'Lock' : 'Unlock'
                  }`"
                  :false-value="1"
                  :true-value="0"
                  @change="changeLock('LOCK_UPLOAD', is_lock_document)"
                  hide-details
                >
                </v-switch>
              </div> </v-col
          ></v-row> </v-card-text
      ></v-card>
    </v-card-text>
  </v-card>

  <div
    class="button-container"
    @mouseenter="isExpanded = true"
    @mouseleave="isExpanded = false"
  >
    <button :class="{ bg2: isMainHover }" class="main-button">แถบนำทาง</button>
    <div
      v-if="isExpanded"
      class="expanded-buttons"
      @mouseenter="isMainHover = true"
      @mouseleave="isMainHover = false"
    >
      <button v-for="i in 10" :key="i" @click="navigateToSection(i)">
        หน้า :
        {{
          i === 8
            ? "8 ตรวจรูปภาพ"
            : i === 9
            ? "9 ตรวจเอกสาร"
            : i === 10
            ? "สถานะนักศึกษา"
            : i
        }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  inlineTranslator,
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import SectionOne from "@/components/sections/Section1.vue";
import SectionTwo from "@/components/sections/Section2.vue";
import Section3ForOfficer from "@/components/sections/Section3ForOfficer.vue";
import UserProvider from "@/services/user.provider";
import { listFilter, getById } from "@/helper/filter";

const userProvider = new UserProvider();

export default {
  name: "MainView",

  data: () => ({
    isMainHover: false,
    isExpanded: false,
    loading: false,
    tabs: "section1",
    // allPageStatus: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    matriculation_statuses: [],
    comment: 1,
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "Postgraduate",
        LEVEL_NAME_TH: "บัณฑิตศึกษา",
      },
    ],
    SectionFirst: {
      level_id_TH: null,
      level_id_EN: null,
      prefix_name_TH: null,
      prefix_name_EN: null,
      faculty_TH: null,
      faculty_EN: null,
      curriculum_TH: null,
      curriculum_EN: null,
    },

    matriculation_id: null,
    matriculation_status_TH: null,
    matriculation_status_EN: null,
    matriculation_status_color: null,
    show_detail_amend: [],
    // is_complete_upload_document: false,
    showComment: false,
    statusPhoto: false,
    commentPhoto: "",
    has_commentDocument: false,

    is_lock_kmitl1: 0,
    is_lock_photo: 0,
    is_lock_document: 0,

    validSurrogated: false,
    inputSurrogatedRegisterId: "",
    surrogetedStudentRules: [
      (v) => !!v || "Register ID is required",
      (v) => /^\d+$/.test(v) || "Register ID must be valid",
    ],

    rand: null,
  }),

  components: {
    SectionOne,
    SectionTwo,
    Section3ForOfficer,
  },

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },

    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },
  },

  methods: {
    dt,
    getById,
    listFilter,
    objectTranslator,
    inlineTranslator,
    toggle_loading(status) {
      this.loading = status;
    },
    async setMatriculationStatus(value) {
      this.loading = true;
      const response = await userProvider
        .setMatriculationStatus({
          uid: this.uid,
          value: value,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("toast.save_successfully"));
        this.fetch_data();
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
    },

    async getMatriculationStd() {
      this.loading = true;
      const ref_data = await userProvider
        .getMatriculationStatusStd(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          // this.$router.push("/login");
        });
      this.matriculation_id = ref_data.MATRICULATION_STATUS_ID;
      this.matriculation_status_TH = ref_data.MATRICULATION_STATUS_NAME_TH;
      this.matriculation_status_EN = ref_data.MATRICULATION_STATUS_NAME_EN;
      this.matriculation_status_color = ref_data.TEXT_CLASS;
      this.loading = false;
    },

    async changeLock(type, value) {
      this.loading = true;
      const response = await userProvider
        .setLock({ uid: this.uid, type: type, value: value })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (response && response.status) {
        this.fetch_all_lock();
        this.$toast.success(this.$t("toast.save_successfully"));
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
    },

    async fetch_all_lock() {
      await this.$store.dispatch("user/getUserInfo");
      this.is_lock_kmitl1 = parseInt(this.surrogated_student_info.LOCK_KMITL1);
      this.is_lock_photo = parseInt(this.surrogated_student_info.LOCK_PHOTO);
      this.is_lock_document = parseInt(
        this.surrogated_student_info.LOCK_UPLOAD
      );
    },

    async getStatusAndCommentPhoto() {
      const commentPhoto = await userProvider
        .getStatusAndCommentPhoto(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.statusPhoto = commentPhoto.UPLOAD_STUDENT_CARD_PHOTO_STATUS;
      this.commentPhoto = commentPhoto.COMMENT_PHOTO;
    },

    async setStatusAndCommentPhoto(value) {
      this.loading = true;
      if (value == 1) {
        this.showComment = false;
        this.commentPhoto = "";
      }
      const response = await userProvider
        .saveStatusAndCommentPhoto({
          uid: this.uid,
          status: value,
          comment: this.commentPhoto,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("toast.save_successfully"));
        this.getStatusAndCommentPhoto();
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
      this.is_lock_photo = value;
    },

    navigateToSection(sectionNumber) {
      // Replace 'sectionX' with the actual IDs of your sections
      const sectionId = `section-${sectionNumber}`;
      const sectionElement = document.getElementById(sectionId);

      if (sectionElement) {
        const sectionTop =
          sectionElement.getBoundingClientRect().top + window.scrollY;
        const windowHeight = window.innerHeight;
        const additionalHeight = windowHeight * 0.1; // 10% of the viewport height

        window.scrollTo({
          top: sectionTop - additionalHeight,
          behavior: "smooth",
        });
      }
    },

    async fetch_data() {
      this.getMatriculationStd();
      this.fetch_all_lock();
      this.getStatusAndCommentPhoto();
      this.getHasCommentDocument();
    },

    async loginSurrogatedStudent() {
      this.loading = true;
      const response = await userProvider
        .getUIDbyRegisterID(this.inputSurrogatedRegisterId)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (response?.uid) {
        sessionStorage.setItem("surrogated_student_uid", response.uid);
        await this.$store.dispatch("user/getUserInfo");
        if (this.surrogated_student_info) {
          this.rand = Math.random();
          this.fetch_data();
        } else {
          sessionStorage.removeItem("surrogated_student_uid");
        }
      }
      this.loading = false;
    },

    async getHasCommentDocument() {
      this.loading = true;
      const data = await userProvider
        .getHasCommentDocument(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (data) this.has_commentDocument = data.status;
      this.loading = false;
    },
  },

  created() {
    if (this.student_id) {
      this.$store.dispatch("user/logoutSurrogatedStudent");
    }
    if (this.uid) {
      this.fetch_data();
    }
  },
};
</script>

<style scoped>
.show-name{
  position: fixed;
  right: 30px;
  top: 150px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px;
  z-index: 9999;
}

span {
  font-size: 16px !important;
}

.inline-h2 {
  color: black;
}
.card-todo-list {
  /* background-color: #3b3939; */
  /* color: wheat; */
  max-width: 1250px;
}

.custom-text {
  color: #f8d7da;
}

.button-container {
  position: fixed;
  top: 100px;
  right: 30px;
  transform: translateY(-50%);
  z-index: 999;
}

.main-button {
  padding: 10px;
  background-color: rgb(233, 92, 151);
  color: white;
  width: 90px;
  border: 1px solid #000000;
  border-radius: 5px;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.5); /* add shadow */
}
.main-button:hover {
  background-color: rgba(255, 0, 106, 1) !important;
}

.bg2 {
  background-color: rgba(255, 0, 106, 1);
}

.expanded-buttons {
  position: absolute;
  top: calc(100%); /* Adjust the distance from the main button */
  left: 0;
  width: 90px;
  background-color: #f9f9f9;
  border: 1px solid #000000;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.expanded-buttons button {
  padding: 5px;
  border: 0.5px solid black;
  transition: background-color 0.3s;
}

.expanded-buttons button:nth-child(1) {
  background-color: #e81416;
  color: white;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(2) {
  background-color: #ffa500;
  color: black;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(3) {
  background-color: #faeb36;
  color: black;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(4) {
  background-color: #79c314;
  color: black;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(5) {
  background-color: #487de7;
  color: white;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(6) {
  background-color: #191970;
  color: white;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(7) {
  background-color: #70369d;
  color: white;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(8) {
  background-color: #a0522d;
  color: white;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(9) {
  background-color: black;
  color: white;
  opacity: 0.6;
}
.expanded-buttons button:nth-child(10) {
  background-color: white;
  color: black;
  opacity: 0.6;
}
.expanded-buttons button:hover {
  opacity: 1;
}
</style>
